import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SessionProvider } from './context/SessionContext';
import Layout from './components/layout/Layout';
import ToastContainer from './components/ToastContainer';
import ProtectedRoute from './components/routing/ProtectedRoute';
import SamlLoginPage from './components/auth/SamlLoginPage';
import SamlAcsPage from './components/auth/SamlAcsPage';
import ReportsListPage from './pages/ReportsListPage';
import ViewReport2014Page from './pages/ViewReport2014Page';
import ManageReportsPage from './pages/ManageReportsPage';
import ManageRolesPage from './pages/ManageRolesPage';
import ConfigExternalRolesPage from './pages/ConfigExternalRolesPage';
import ServiceConfigPage from './pages/ServiceConfigPage';
import ErrorPage from './pages/ErrorPage';
import AddEditReportPage from './pages/AddEditReportPage';
import ManageMenu from './pages/ManageMenu';
import TestSignalR from './pages/TestSignalR';
import './App.css';
const BASE_URL = '/ext';
function App() {
  return (
    <AuthProvider>
      <SessionProvider>
        <Router basename={BASE_URL}>
          <div className="app-container">
            <Layout>
              <Routes>
                {/* Root route - SAML login page */}
                <Route path="/" element={<SamlLoginPage />} />
                
                {/* SAML authentication routes */}
                <Route path="/saml/acs" element={<SamlAcsPage />} />
                
                {/* Protected routes */}
                <Route path="/reports-list" element={<ProtectedRoute element={<ReportsListPage />} />} />
                <Route path="/view-report-2014/:reportId" element={<ProtectedRoute element={<ViewReport2014Page />} />} />
                <Route path="/manage-reports" element={<ProtectedRoute element={<ManageReportsPage />} />} />
                <Route path="/add-report" element={<ProtectedRoute element={<AddEditReportPage />} />} />
                <Route path="/edit-report/:reportId" element={<ProtectedRoute element={<AddEditReportPage />} />} />
                <Route path="/manage-roles" element={<ProtectedRoute element={<ManageRolesPage />} />} />
                <Route path="/manage-menu" element={<ProtectedRoute element={<ManageMenu />} />} />
                <Route path="/config-external-roles" element={<ProtectedRoute element={<ConfigExternalRolesPage />} />} />
                <Route path="/service-config" element={<ProtectedRoute element={<ServiceConfigPage />} />} />
                
                {/* Public routes */}
                <Route path="/error" element={<ErrorPage />} />
                <Route path="/signalr-test" element={<TestSignalR />} />
                <Route path="*" element={<ErrorPage />} />
              </Routes>
            </Layout>
            <ToastContainer />
          </div>
        </Router>
      </SessionProvider>
    </AuthProvider>
  );
}

export default App;
